/* eslint-disable camelcase */
/**
 * It will search a license list to find a particular feature, typically accessed from the global store
 *
 * @param licenseList
 * @param featureName
 * @returns {*}
 */
export const findLicenseFeature = (licenseList, featureName) => {
  return licenseList?.find((l) => {
    return l.features.find((a) => a === featureName);
  });
};

export const findFeatureFromLicenseList = (licenseList, featureName) => {
  return licenseList?.some((ls) => {
    return ls.features.includes(featureName);
  });
};

export const getLicenseFeatures = (licenseList) => {
  const licenseFeatures = [];
  licenseList?.forEach((license) => {
    license.features.forEach((feature) => {
      licenseFeatures.push(feature);
    });
  });
  return licenseFeatures;
};

const assignedFeature = (license, featureName) => {
  const {
    license_definition: { assigned_services } = {},
    licenseDefinition: { assignedServices } = {},
  } = license;

  return (
    assigned_services || assignedServices
  ).some(({ assigned_features, assignedFeatures }) =>
    (assigned_features || assignedFeatures).some((f) => f.name === featureName),
  );
};

export const findAssignedFeature = (licenseList, featureName) => {
  return licenseList?.some((license) => assignedFeature(license, featureName));
};

export const filterLicensesByFeature = (licenseList = [], featureName) => {
  return licenseList.filter((license) => assignedFeature(license, featureName));
};

export const assignedLicensesFeatureList = (licenses) => {
  const featureList = licenses
    .map((l) => {
      const assignedServices = (
        l.license_definition?.assigned_services ||
        l.licenseDefinition.assignedServices
      )
        .map((s) => {
          return (s.assigned_features || s.assignedFeatures).map((f) => f.name);
        })
        .reduce((state, ele) => [...state, ...ele], []);

      return assignedServices;
    })
    .reduce((state, ele) => [...state, ...ele], []);

  return featureList;
};
